const ERROR_CONSTANTS = {
  GENERIC_ERROR_TOAST: "An error occurred. Please try again later.",
  GENERIC_ERROR_VIEW: "An error occurred. Please try again later.",
  GENERIC_ERROR_TEXT: "An error occurred. Please try again later.",
  CHECKOUT_ERROR_VIEW: {
    MESSAGE: "Checkout is not available right now. Please try again later.",
    BUTTON_TEXT: "Return to Course Listing"
  },
  COURSE_REFUND_ERROR_MODAL: {
    MESSAGE: "Refund Failed. Please try again later.",
    BUTTON_TEXT: "Ok"
  },
  COURSE_CONTACT_ERROR_MODAL: {
    MESSAGE: "An error occurred. Please try again later.",
  }
}
Object.freeze(ERROR_CONSTANTS)
export default ERROR_CONSTANTS